import React, { useEffect, useState, useRef } from "react";
import "./App.css";
import { ReactTagManager } from "react-gtm-ts";

const tagManagerArgs = {
  code: "GTM-WZQPMC7",
};

interface PlanOption {
  name: string;
  price: number;
  features: string[];
  priceId: string;
}

const PricingPopup: React.FC<{
  isOpen: boolean;
  onClose: () => void;
  instance: any;
}> = ({ isOpen, onClose, instance }) => {
  const plans: PlanOption[] = [
    {
      name: "Lite",
      price: 8,
      priceId: "pri_01jkfbr8vjf3vb5p4p574vvh32",
      features: [
        "100 - 150 Followers /mo",
        "Instant Results From Day 1",
        "Targeted, Organic Followers"
      ]
    },
    {
      name: "Standard",
      price: 24,
      priceId: "pri_01jkfbrjy5y0qjxgfdfcn7yy0w",
      features: [
        "Benefits from Lite, +",
        "1,000 - 1,500 Followers /mo",
        "AI-Targeting",
        "Audience Targeting"
      ]
    },
    {
      name: "Plus",
      price: 49,
      priceId: "pri_01jkfbrzp8nbba7wrefzv9xwh0",
      features: [
        "Everything in Standard, +",
        "2,500 - 3,500+ Followers /mo",
        "Get comments and story interactions"
      ]
    },
    {
      name: "Pro",
      price: 82,
      priceId: "pri_01jkfbsb7b2mrq6137xqa73b8a",
      features: [
        "Everything in Plus, +",
        "3,500 - 5,000+ Followers /mo",
        "Priority Support"
      ]
    }
  ];

  const handlePlanSelect = (plan: PlanOption) => {
    window.open(
      instance?.storeProfile
        ? encodeURI(
            "https://www.certifiedcode.us/upgrade/apps?checkout=" +
              JSON.stringify({
                settings: {
                  allowLogout: false,
                  allowDiscountRemoval: false,
                },
                items: [
                  {
                    priceId: plan.priceId,
                    quantity: 1,
                  },
                ],
                customer: {
                  email: instance.storeProfile.account.accountEmail,
                  business: {
                    name: instance.storeProfile.account.accountName,
                  },
                  address: {
                    countryCode: instance.storeProfile.company.countryCode,
                    postalCode: instance.storeProfile.company.postalCode,
                    city: instance.storeProfile.company.city,
                  },
                },
                customData: {
                  store_id: `${instance.store_id}`,
                },
              })
          )
        : undefined,
      "_blank"
    );
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div className="modal-content" style={{
        backgroundColor: 'white',
        padding: '2rem',
        borderRadius: '8px',
        maxWidth: '1000px',
        width: '90%',
        maxHeight: '90vh',
        overflowY: 'auto'
      }}>
        <div style={{ textAlign: 'right', marginBottom: '1rem' }}>
          <button onClick={onClose} style={{
            background: 'none',
            border: 'none',
            fontSize: '1.5rem',
            cursor: 'pointer'
          }}>&times;</button>
        </div>
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
          gap: '1rem',
          padding: '1rem'
        }}>
          {plans.map((plan) => (
            <div key={plan.name} style={{
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              padding: '1.5rem',
              textAlign: 'center',
              backgroundColor: '#fff',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
              <h3 style={{ margin: '0 0 1rem 0', color: '#2964de' }}>{plan.name} plan</h3>
              <div style={{ fontSize: '2rem', fontWeight: 'bold', margin: '1rem 0' }}>
                <span style={{ fontSize: '1rem', verticalAlign: 'top' }}>$</span>
                {plan.price}
                <span style={{ fontSize: '1rem' }}>/month</span>
              </div>
              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: '1rem 0',
                textAlign: 'left'
              }}>
                {plan.features.map((feature, index) => (
                  <li key={index} style={{
                    margin: '0.5rem 0',
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    <span style={{ marginRight: '0.5rem', color: '#2964de' }}>✓</span>
                    {feature}
                  </li>
                ))}
              </ul>
              <button
                onClick={() => handlePlanSelect(plan)}
                style={{
                  backgroundColor: '#2964de',
                  color: 'white',
                  border: 'none',
                  padding: '0.8rem 1.5rem',
                  borderRadius: '4px',
                  cursor: 'pointer',
                  width: '100%',
                  fontWeight: 'bold'
                }}
              >
                Select Plan
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

function App() {
  ReactTagManager.init(tagManagerArgs);
  const intercomInitialized = useRef(false);
  const BASE_URL = "https://wix.certifiedcode.io/ecwid-socialboost";
  const [instance, setInstance] = React.useState({} as any);
  const [isPricingOpen, setIsPricingOpen] = useState(false);

  useEffect(() => {
    if (!intercomInitialized.current && instance.intercomToken && instance.storeProfile && instance.app) {
      const name = instance.storeProfile.account.accountName;
      const registrationDate = new Date(
        instance.storeProfile.account.registrationDate
      );
      const created_at = Math.floor(registrationDate.getTime() / 1000);
      const phone = instance.storeProfile.company.phone;
      const email = instance.storeProfile.account.accountEmail;
      const utm_source = instance.app.client_id;
      const options = {
        email,
        name,
        created_at,
        phone,
        user_hash: instance.intercomToken,
        utm_source,
      };
      window.Intercom("boot", options);
      intercomInitialized.current = true;
    }
  }, [instance]);

  useEffect(() => {
    try {
      // Initialize the application
      window.EcwidApp.init({
        app_id: "social-boost",
        autoloadedflag: true,
        autoheight: false,
      });

      // Initial instance fetch
      getInstance();

      // Function to update height
      const updateHeight = () => {
        var body = document.body,
          html = document.documentElement;

        var height = Math.max(
          body.scrollHeight,
          body.offsetHeight,
          html.clientHeight,
          html.scrollHeight,
          html.offsetHeight
        );

        window.EcwidApp.setSize({ height: height });
      };

      // Initial height update
      updateHeight();

      // Set up intervals for both instance and height updates
      const instanceIntervalId = setInterval(getInstance, 10000);
      const heightIntervalId = setInterval(updateHeight, 1000);

      // Cleanup intervals on component unmount
      return () => {
        clearInterval(instanceIntervalId);
        clearInterval(heightIntervalId);
      };
    } catch (error) {
      console.error(error);
    }
  }, []);

  function getInstance() {
    fetch(
      BASE_URL + "/_functions/@certifiedcode/ecwid-repluggable-backend/auth",
      {
        headers: {
          Authorization: new URLSearchParams(window.location.search).get(
            "payload"
          )!,
        },
      }
    )
      .then((response) => response.json())
      .then((payload) => {
        setInstance(payload);
        window.EcwidApp.ready();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

  return (
    <div className="settings-page cf">
      <div className="settings-page__header">
        <div className="settings-page__titles settings-page__titles--left">
          <h1 className="settings-page__title">
            SocialBoost: Followers Growth
          </h1>
          <div className="settings-page__subtitle">
            Level up your social media game with SocialBoost
          </div>
        </div>

        <div className="named-area">
          <div className="named-area__header">
            <div className="named-area__titles">
              <div className="named-area__title">Premium Social Growth Features</div>
            </div>
            <div className="named-area__description">
              Transform your social media presence with our AI-powered growth solution. Our plans offer 
              customizable follower growth from 100 to 5,000+ organic followers monthly. Get detailed analytics 
              and engagement insights delivered straight to your inbox.
            </div>
          </div>
          <div className="named-area__body">
            <div
              className="a-card a-card--normal"
              style={{ backgroundColor: "#2964de" }}
            >
              <div className="a-card__paddings">
                <div className="upgrade-element upgrade-element--inverted">
                  <div className="upgrade-element__core">
                    <div className="upgrade-element__data">
                      <div className="upgrade-element__title">
                        Start Growing Your Following Today
                      </div>
                      <div className="upgrade-element__content">
                        <div className="upgrade-element__text">
                          Get real, engaged followers with our AI-powered targeting system designed to match 
                          your brand's unique identity and audience preferences.
                        </div>
                        <div className="upgrade-element__action">
                          {instance.store_id ? (
                            !instance?.subscription ? (
                              <button
                                type="button"
                                className="btn btn-medium btn-success upgrade-element__button"
                                onClick={() => setIsPricingOpen(true)}
                              >
                                <span className="svg-icon">
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="488px"
                                    height="466px"
                                    viewBox="0 0 488 466"
                                    version="1.1"
                                    focusable="false"
                                  >
                                    <path d="M382.437 465.1 C379.306 465.1 376.2 464.3 373.3 462.8 L244 394.8 L114.72 462.8 C108.084 466.3 100 465.7 94 461.3 C87.919 456.9 84.9 449.4 86.1 442 L110.84 298 L6.254 196.1 C0.897 190.9 -1.1 183 1.3 175.9 C3.595 168.8 9.7 163.6 17.2 162.5 L161.686 141.5 L226.336 10.6 C232.953 -2.9 255 -2.9 261.6 10.6 L326.295 141.5 L470.817 162.5 C478.241 163.6 484.4 168.8 486.7 175.9 C489.032 183.1 487.1 190.9 481.7 196.1 L377.14 298.1 L401.185 438.3 C402.051 440.4 402.5 442.8 402.5 445.4 C402.505 456.3 393.7 465.1 382.8 465.1 C382.754 465.1 382.6 465.1 382.4 465.1 L382.437 465.1 Z"></path>
                                  </svg>
                                </span>
                                <span>Start Your Growth Journey</span>
                              </button>
                            ) : (
                              <button
                                className="btn btn-medium btn-success upgrade-element__button"
                                onClick={() => {
                                  window.Intercom("showSpace", "tickets");
                                }}
                              >
                                Track Status
                              </button>
                            )
                          ) : (
                            <div className="loader"></div>
                          )}
                        </div>
                        <div className="supported-platforms" style={{ marginTop: '20px', textAlign: 'left' }}>
                          <div style={{ fontSize: '14px', color: '#ffffff', marginBottom: '10px' }}>Supported Platforms</div>
                          <div style={{ display: 'flex', gap: '20px' }}>
                            <svg viewBox="0 0 24 24" width="24" height="24" fill="#ffffff">
                              <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                            </svg>
                            <svg viewBox="0 0 24 24" width="24" height="24" fill="#ffffff">
                              <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                            </svg>
                            <svg viewBox="0 0 24 24" width="24" height="24" fill="#ffffff">
                              <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                            </svg>
                            <svg viewBox="0 0 24 24" width="24" height="24" fill="#ffffff">
                              <path d="M22.675 0h-21.35c-.732 0-1.325.593-1.325 1.325v21.351c0 .731.593 1.324 1.325 1.324h11.495v-9.294h-3.128v-3.622h3.128v-2.671c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.795.715-1.795 1.763v2.313h3.587l-.467 3.622h-3.12v9.293h6.116c.73 0 1.323-.593 1.323-1.325v-21.35c0-.732-.593-1.325-1.325-1.325z"/>
                            </svg>
                            <svg viewBox="0 0 24 24" width="24" height="24" fill="#ffffff">
                              <path d="M21.593 7.203c-.23-.858-.905-1.535-1.762-1.766C18.265 5.007 12 5 12 5S5.736 4.993 4.169 5.404c-.858.23-1.534.908-1.766 1.766C2 8.769 2 12 2 12s0 3.234.437 4.797c.23.858.905 1.535 1.762 1.766 1.567.412 7.831.419 7.831.419s6.265.007 7.831-.404c.858-.23 1.534-.908 1.766-1.766C22 15.234 22 12 22 12s0-3.234-.437-4.797zM10 15V9l5.177 3L10 15z"/>
                            </svg>
                          </div>
                        </div>
                      </div>
                      <div className="upgrade-element__note">
                        <div>Premium growth features available with all plans</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="named-area">
          <div className="named-area__header">
            <div className="named-area__titles">
              <div className="named-area__title">
                Why Choose SocialBoost?
              </div>
            </div>
            <div className="named-area__description">
              Discover how our AI-powered growth solution can transform your social media presence
            </div>
          </div>
          <div className="named-area__body">
            <div className="a-card a-card--normal">
              <div className="a-card__paddings">
                <div>
                  <div className="promo-row">
                    <div className="promo-row__content">
                      <ul className="titled-items-list">
                        <li className="titled-item titled-items-list__item">
                          <div className="titled-item__title">
                            AI-Targeting Algorithms
                          </div>
                          <div className="titled-item__content">
                            Reach your ideal audience with precision using our advanced AI-driven targeting tools.
                          </div>
                        </li>
                        <li className="titled-item titled-items-list__item">
                          <div className="titled-item__title">
                            Steady Followers Growth
                          </div>
                          <div className="titled-item__content">
                            Experience consistent growth with 100 to 5,000+ new organic followers monthly, based on your plan.
                          </div>
                        </li>
                        <li className="titled-item titled-items-list__item">
                          <div className="titled-item__title">
                            Interactive Engagement
                          </div>
                          <div className="titled-item__content">
                            Boost your engagement with real comments, story interactions, and meaningful connections.
                          </div>
                        </li>
                        <li className="titled-item titled-items-list__item">
                          <div className="titled-item__title">
                            Seamless Audience Targeting
                          </div>
                          <div className="titled-item__content">
                            Customize your growth strategy to maximize relevance and potential with your target audience.
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="named-area__footer">
            <div className="named-area__footer-description"></div>
          </div>
        </div>
      </div>
      <PricingPopup
        isOpen={isPricingOpen}
        onClose={() => setIsPricingOpen(false)}
        instance={instance}
      />
    </div>
  );
}

export default App;
